import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(storefront)/c/[slug]/error.tsx");
